import { Link, useLocation } from 'react-router-dom';
import { Home, Camera, Leaf, User } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavItemProps {
  icon: React.ElementType;
  label: string;
  to: string;
  isPrimary?: boolean;
}

function NavItem({ icon: Icon, label, to, isPrimary }: NavItemProps) {
  const location = useLocation();
  const isActive = location.pathname === to;

  if (isPrimary) {
    return (
      <Link
        to={to}
        className="relative -mt-4 flex flex-col items-center justify-center gap-1 min-w-[64px] min-h-[44px] no-underline transition-transform duration-200 active:scale-95"
      >
        <div className={cn(
          "w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-all duration-300",
          isActive 
            ? "bg-primary scale-110 shadow-primary/40" 
            : "bg-primary/80 hover:bg-primary hover:scale-105"
        )}>
          <Icon className="h-6 w-6 text-primary-foreground" />
        </div>
        <span className={cn(
          "text-xs font-medium mt-1 transition-colors duration-200",
          isActive ? "text-primary" : "text-muted-foreground"
        )}>
          {label}
        </span>
      </Link>
    );
  }

  return (
    <Link
      to={to}
      className="relative flex flex-col items-center justify-center gap-1 min-w-[64px] min-h-[44px] no-underline transition-all duration-200 active:scale-95"
    >
      {/* Indicador de ativo */}
      {isActive && (
        <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary animate-scale-in" />
      )}
      
      {/* Background highlight quando ativo */}
      <div className={cn(
        "flex flex-col items-center justify-center gap-1 p-2 rounded-xl transition-all duration-300",
        isActive && "bg-primary/10"
      )}>
        <Icon className={cn(
          "h-5 w-5 transition-all duration-300",
          isActive 
            ? "text-primary scale-110" 
            : "text-muted-foreground hover:text-foreground"
        )} />
        <span className={cn(
          "text-xs font-medium transition-all duration-300",
          isActive 
            ? "text-primary font-semibold" 
            : "text-muted-foreground"
        )}>
          {label}
        </span>
      </div>
    </Link>
  );
}

export function BottomNavigation() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-[100] bg-background border-t border-border safe-area-pb">
      <div className="flex items-end justify-around py-2 px-4 max-w-lg mx-auto">
        <NavItem icon={Home} label="Início" to="/" />
        <NavItem icon={Camera} label="Identificar" to="/identify" isPrimary />
        <NavItem icon={Leaf} label="Coleção" to="/collection" />
        <NavItem icon={User} label="Perfil" to="/profile" />
      </div>
    </nav>
  );
}
